import * as React from 'react';

import { type VariantProps, cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
    'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                default:
                    'border-transparent bg-[#D0E6E6] text-slate-700 hover:bg-[#D0E6E6]/80',
                secondary:
                    'border-transparent bg-slate-100 text-secondary-foreground hover:bg-primary/80',
                destructive:
                    'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
                success:
                    'border-transparent bg-green-100 text-green-700 hover:bg-green-100',
                warning:
                    'border-transparent bg-yellow-100 text-yellow-800 hover:bg-yellow-200',
                outline: 'text-foreground',
                critical:
                    'border-transparent bg-red-100 text-red-700 hover:bg-red-200',
                alert: 'border-transparent bg-amber-50 text-amber-700 hover:bg-amber-100',
                info: 'border-transparent bg-slate-50 text-slate-600 hover:bg-slate-100',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return (
        <div className={cn(badgeVariants({ variant }), className)} {...props} />
    );
}

export { Badge, badgeVariants };
